<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

/**
 * Starter component
 */
export default {
  page: {
    title: "Permissão Negada",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Permissão Negada",
      items: [
        {
          text: "Home",
          href: "/"
        },
        {
          text: "Permissão Negada",
          active: true
        }
      ],
    };
  },
  created() {
    window.addEventListener("scroll", this.windowScroll);
  },
  mounted() {
    this.start = new Date(this.starttime).getTime();
    this.end = new Date(this.endtime).getTime();
    // Update the count down every 1 second
    this.timerCount(this.start, this.end);
    this.interval = setInterval(() => {
      this.timerCount(this.start, this.end);
    }, 1000);
  },
  methods: {
    timerCount: function (start, end) {
      // Get todays date and time
      var now = new Date().getTime();

      // Find the distance between now an the count down date
      var distance = start - now;
      var passTime = end - now;

      if (distance < 0 && passTime < 0) {
        clearInterval(this.interval);
        return;
      } else if (distance < 0 && passTime > 0) {
        this.calcTime(passTime);
      } else if (distance > 0 && passTime > 0) {
        this.calcTime(distance);
      }
    },
    calcTime: function (dist) {
      // Time calculations for days, hours, minutes and seconds
      this.days = Math.floor(dist / (1000 * 60 * 60 * 24));
      this.hours = Math.floor(
          (dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      this.minutes = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60));
      this.seconds = Math.floor((dist % (1000 * 60)) / 1000);
    },
  },

};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div>
      <div class="home-btn d-none d-sm-block">
        <router-link to="/" class="text-dark">
          <i class="fas fa-home h2"></i>
        </router-link>
      </div>
      <section class="my-5 pt-sm-5">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">

              <div class="row justify-content-center">
                <div class="col-sm-4">
                  <div class="maintenance-img">
                    <img
                        src="@/assets/images/coming-soon.svg"
                        alt
                        class="img-fluid mx-auto d-block"
                    />
                  </div>
                </div>
              </div>
              <h3 class="mt-5">Desculpe mas falta algum parâmetro para seu usuário</h3>
              <p>Favor verificar as informações abaixo.</p>

              <div class="row">
                <div class="col-md-4">
                  <div class="card mt-4 maintenance-box">
                    <div class="card-body">
                      <i class="bx bx-broadcast mb-4 h1 text-primary"></i>
                      <h5 class="font-size-15 text-uppercase">
                        Conexão com Internet
                      </h5>
                      <p class="text-muted mb-0">
                        Sua conexão com a internet está estável?
                        Chegou a testar outros sites?
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="card mt-4 maintenance-box">
                    <div class="card-body">
                      <i class="bx bx-shield mb-4 h1 text-primary"></i>
                      <h5 class="font-size-15 text-uppercase">
                        Perfil Configurado
                      </h5>
                      <p class="text-muted mb-0">
                        Confirmou com o administrador de seu sistema
                        que seu perfil foi devidamente configurado?
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="card mt-4 maintenance-box">
                    <div class="card-body">
                      <i class="bx bxl-whatsapp mb-4 h1 text-primary"></i>
                      <h5 class="font-size-15 text-uppercase">
                        Precisa de Suporte?
                      </h5>
                      <p class="text-muted mb-0">
                        Basta clicar no link e um de nossos
                        atendentes vai te ajudar...
                        <a
                            href=" https://wa.me/5527981240093"
                            target="_blank"
                            class="text-decoration-underline"
                        >Whatsapp Suporte Técnico</a
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </div>

<!--              <div class="text-center">-->
<!--&lt;!&ndash;                <router-link to="/" class="d-block auth-logo">&ndash;&gt;-->
<!--&lt;!&ndash;                  <img&ndash;&gt;-->
<!--&lt;!&ndash;                      src="@/assets/images/logo-dark.png"&ndash;&gt;-->
<!--&lt;!&ndash;                      alt=""&ndash;&gt;-->
<!--&lt;!&ndash;                      height="20"&ndash;&gt;-->
<!--&lt;!&ndash;                      class="auth-logo-dark mx-auto"&ndash;&gt;-->
<!--&lt;!&ndash;                  />&ndash;&gt;-->
<!--&lt;!&ndash;                  <img&ndash;&gt;-->
<!--&lt;!&ndash;                      src="@/assets/images/logo-light.png"&ndash;&gt;-->
<!--&lt;!&ndash;                      alt=""&ndash;&gt;-->
<!--&lt;!&ndash;                      height="20"&ndash;&gt;-->
<!--&lt;!&ndash;                      class="auth-logo-light mx-auto"&ndash;&gt;-->
<!--&lt;!&ndash;                  />&ndash;&gt;-->
<!--&lt;!&ndash;                </router-link>&ndash;&gt;-->
<!--                <div class="row justify-content-center mt-0">-->
<!--                  <div class="col-sm-4">-->
<!--                    <div class="maintenance-img">-->
<!--                      <img-->
<!--                          src="@/assets/images/coming-soon.svg"-->
<!--                          alt=""-->
<!--                          class="img-fluid mx-auto d-block"-->
<!--                      />-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <h4 class="mt-5">Let's get started with Skote</h4>-->
<!--                <p class="text-muted">-->
<!--                  It will be as simple as Occidental in fact it will be-->
<!--                  Occidental.-->
<!--                </p>-->

<!--&lt;!&ndash;                <div class="row justify-content-center mt-5">&ndash;&gt;-->
<!--&lt;!&ndash;                  <div class="col-md-8">&ndash;&gt;-->
<!--&lt;!&ndash;                    <div class="counter-number ico-countdown">&ndash;&gt;-->
<!--&lt;!&ndash;                      <div class="coming-box">&ndash;&gt;-->
<!--&lt;!&ndash;                        {{ days }}&ndash;&gt;-->
<!--&lt;!&ndash;                        <span>Days</span>&ndash;&gt;-->
<!--&lt;!&ndash;                      </div>&ndash;&gt;-->
<!--&lt;!&ndash;                      <div class="coming-box">&ndash;&gt;-->
<!--&lt;!&ndash;                        {{ hours }}&ndash;&gt;-->
<!--&lt;!&ndash;                        <span>Hours</span>&ndash;&gt;-->
<!--&lt;!&ndash;                      </div>&ndash;&gt;-->
<!--&lt;!&ndash;                      <div class="coming-box">&ndash;&gt;-->
<!--&lt;!&ndash;                        {{ minutes }}&ndash;&gt;-->
<!--&lt;!&ndash;                        <span>Minutes</span>&ndash;&gt;-->
<!--&lt;!&ndash;                      </div>&ndash;&gt;-->
<!--&lt;!&ndash;                      <div class="coming-box">&ndash;&gt;-->
<!--&lt;!&ndash;                        {{ seconds }}&ndash;&gt;-->
<!--&lt;!&ndash;                        <span>Seconds</span>&ndash;&gt;-->
<!--&lt;!&ndash;                      </div>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->
<!--&lt;!&ndash;                  </div>&ndash;&gt;-->
<!--&lt;!&ndash;                  &lt;!&ndash; end col&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--&lt;!&ndash;                &lt;!&ndash; end row&ndash;&gt;&ndash;&gt;-->
<!--              </div>-->
            </div>
          </div>
        </div>
      </section>
    </div>

  </Layout>
</template>